import { render, staticRenderFns } from "./xcxScheme.vue?vue&type=template&id=be7b1eaa"
import script from "./xcxScheme.vue?vue&type=script&lang=js"
export * from "./xcxScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports